import { TableColumn } from "react-data-table-component";

import EditIcon from "@/assets/svg/EditIcon";
import { readableProgramType } from "@/pages/Users/columns";
import { transformDate } from "@/utils/date-utils";

import { TableCell } from "./styles";
import { TreatmentHistoryRow } from "./types";

export const TREATMENT_HISTORY_COLUMNS: TableColumn<TreatmentHistoryRow>[] = [
  {
    name: "Program Type",
    selector: (row) => (row.programType ? row.programType : ""),
    cell: (row) =>
      row.programType ? <TableCell>{readableProgramType(row.programType)}</TableCell> : "",
    width: "150px",
    center: true,
    // sortable: true,
  },
  {
    name: "Round #",
    selector: (row) => (row.roundNumber ? row.roundNumber : ""),
    width: "100px",
    center: true,
    cell: (row) => (row.roundNumber ? <TableCell>{row.roundNumber}</TableCell> : ""),
  },
  {
    name: "Start Date",
    selector: (row) => row.startDate,
    cell: (row) => (row.startDate ? <TableCell>{transformDate(row.startDate)}</TableCell> : ""),
    // sortable: true,
    width: "120px",
    center: true,
  },
  {
    name: "End Date",
    selector: (row) => row.endDate,
    cell: (row) => (row.endDate ? <TableCell>{transformDate(row.endDate)}</TableCell> : ""),
    // sortable: true,
    width: "120px",
    center: true,
  },
  {
    name: "Therapist",
    selector: (row) => row.specialist.firstName,
    cell: (row) => (row.specialist ? <TableCell>{row.specialist.firstName}</TableCell> : ""),
    width: "120px",
    center: true,
  },
  {
    name: "Playlist Status",
    selector: (row) => row?.status,
    cell: (row) => {
      if (row.programType === "maintenance") {
        return <TableCell>-</TableCell>;
      }
      return row?.status ? <TableCell>{row.status.toLowerCase()}</TableCell> : "-";
    },
    width: "120px",
    center: true,
  },
];

export const createTreatmentHistoryColumnsWithEdit = (
  onEdit: (row: TreatmentHistoryRow) => void
): TableColumn<TreatmentHistoryRow>[] => [
  ...TREATMENT_HISTORY_COLUMNS,
  {
    name: "Actions",
    cell: (row: TreatmentHistoryRow) => (
      <TableCell>
        <EditIcon onClick={() => onEdit(row)} />
      </TableCell>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "80px",
    center: true,
  },
];
